module.exports = __webpack_public_path__ + "img/medical-rays.f7f9c643.svg";